import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AddToCartContext } from './AddToCartContext';
import CartItem from './CartItem';

import './CartDropdown.css'
import CartDropdownFooter from './CartDropdownFooter';
import WishlistSharingButton from '../buttons/WishlistSharingButton';
import { isMobileDevice } from "../../../utils/DeviceDetector";
import { constructUrl } from '../../../utils/UrlConstructor';
import { getMobileOS } from 'web-store-modules/packages/obsess-device-detector';
import { WhatsappButtonClicked, EmailButtonClicked, SMSButtonClicked, ContactButtonClicked } from '../../../utils/Analytics';
import { storeTrans } from '../../../utils/StoreTranslator';
import { brazilMKId, argentinaMKId, peruMKId, spainMKId, colombiaMKId, mexicoMKId, russiaMKId, ukMKId, portugalMKId, getCheckoutURL, polandMKId, lithuaniaMkId, moldovaMKId } from '../../../utils/StoreConfigManager';
import { formatPriceString } from '../modals/product/extended-product-modal/util/ProductModalHelpers';
import { CheckoutClicked } from '../../../utils/Analytics';

const isMobile = isMobileDevice();
const whatsappIcon = 'https://cdn.obsess-vr.com/mary-kay/Whatsapp.png';
const smsIcon = 'https://cdn.obsess-vr.com/mary-kay/SMS.png';
const emailIcon = 'https://cdn.obsess-vr.com/mary-kay/Email.png';
const storeWithShareBtn = [ukMKId, mexicoMKId, portugalMKId, argentinaMKId, brazilMKId, lithuaniaMkId, moldovaMKId];
const fontFamilyByStoreArr = [polandMKId, lithuaniaMkId];
const CartDropdown = ({ showDropdown, menuTextFontStyle, removeText, storeId}) => {
    const { cartList, pricePrefix, removeFromCart } = useContext(AddToCartContext);
    const [showShareIcon, setShowShareIcon] = useState(false);
    const [showSocialIcon, setSocialIcon] = useState(false);
    const [showCheckoutIcon, setCheckoutIcon] = useState(false);
    const changeLink = () => {
        let link = ''
        if (storeId === brazilMKId) {
            link = 'https://localizador.marykay.com.br/?o=suite13';
        } else if (storeId === argentinaMKId) {
            link = 'https://localizador.marykay.com.ar/?o=suite13';
        } else if (storeId === peruMKId) {
            link = 'https://localizador.marykay.com.pe/?o=suite13';
        } else if (storeId === spainMKId) {
            link = 'https://www.marykay.es/es-es/find-an-independent-beauty-consultant';
        } else if (storeId === colombiaMKId) {
            link = 'https://localizador.marykay.com.co/?o=suite13';
        } else if (storeId === mexicoMKId) {
            link = 'https://localizador.marykay.com.mx/?o=suite13';
        } else if (storeId === russiaMKId) {
            link = 'https://www.marykay.ru/ru-ru/find-an-independent-beauty-consultant';
        } else if (storeId === ukMKId) {
            link = 'https://www.marykay.co.uk/en-gb/find-an-independent-beauty-consultant';
        } else if (storeId === portugalMKId) {
            link = 'https://www.marykay.pt/pt-pt/contactar-uma-cb';
        } else if(storeId === lithuaniaMkId) {
            link = 'https://www.marykay.lt/';
        } else if(storeId === moldovaMKId) {
            link = 'https://marykay.co.uk/en-gb/find-an-independent-beauty-consultant';
        } else {
            link = 'https://www.marykay.com.mx/es-mx/localizador-de-consultoras-mary-kay?cid=suite13'
        }

        return link;
    }

    const fontFamilyByStore = {
        fontFamily: fontFamilyByStoreArr.includes(storeId) ? "MaryKaySansMedium" : null
    };

    useEffect(() => {
        if(storeId === spainMKId) setCheckoutIcon(true);
        if(storeId === lithuaniaMkId) setShowShareIcon(true);
    }, []);

    const fnSocialIcon = () => {
        setSocialIcon(!showSocialIcon)
        setCheckoutIcon(false)
    }

    const fnCheckoutIcon = () => {
        setCheckoutIcon(!showCheckoutIcon)
        setSocialIcon(false)
    }

    const renderCartItems = () => {
        return (
            <div className='cart-dropdown-item-container'>
                {cartList.map((item, index) => {
                    return (
                        <CartItem
                            key={index}
                            name={item.TITLE}
                            price={item.PRICE}
                            prefix={item.PRICECURRENCY}
                            thumbnail={item.DOWNSIZED_THUMBNAIL}
                            menuTextFontStyle={menuTextFontStyle}
                            removeFromCart={removeFromCart}
                            color={item.COLOR}
                            sku={item.SKU}
                            removeText={removeText}
                            fontFamilyByStore={fontFamilyByStore}
                        />
                    )
                })}
            </div>
        );
    }

    const renderWishlistText = () => {
        return storeTrans[storeId]['WishlistText'];
    }

    const renderSharingButtons = () => {
        const wishListEmail = cartList.map(item => {
            return `   ` + item.TITLE.replace(/<(\/*)sup[^>]*>/g,"").replace("&reg;","®").replace("&bdquo;",'"').replace("&ldquo;",'"').replace("p/", "").replace("c/", "").replaceAll("<br />", "") + `  ` + formatPriceString(item.PRICE, storeTrans[storeId]['currency'], item.PRICE_SUFFIX);
        })

        const wishList = cartList.map(item => {
            return `\n${storeTrans[storeId]['ProductName']}:  ` + item.TITLE + `\n${storeTrans[storeId]['ProductPrice']}:  ` + formatPriceString(item.PRICE, storeTrans[storeId]['currency']).replace(/(<([^>]+)>)/gi, "");
        })

        const wishListPeru = cartList.map(item => {
            return `\n${storeTrans[storeId]['ProductName']}:  ` + item.TITLE + `\n${storeTrans[storeId]['ProductPrice']}:  ` + formatPriceString(item.PRICE, storeTrans[storeId]['currency']);
        })

        const emailLinkPeru = `mailto:?subject=${storeTrans[storeId]['Subject']}&body=` + storeTrans[storeId]['Message1'] + storeTrans[storeId]['Message2'] + encodeURIComponent(wishListEmail.join('; ') + ';');
        const emailLink = `mailto:?subject=${storeTrans[storeId]['Subject']}&body=` + storeTrans[storeId]['Message1'] + ((storeId == portugalMKId || storeId == moldovaMKId) ? "" + encodeURIComponent(wishListEmail.join(' ')) : storeTrans[storeId]['Message2'] + encodeURIComponent(wishListEmail.join('; ') + ';'));
        //"mailto:someone@yoursite.com?cc=someoneelse@yoursite.com&bcc=another@theirsite.com&subject=Houston%2C+we+have+a+problem%21";
        //'%0AProduct SKU: ' + item.SKU
        const whatsappLinkPeru = "https://web.whatsapp.com/send?text=" + storeTrans[storeId]['Message1'] + storeTrans[storeId]['Message2'] + encodeURIComponent(wishListPeru.join('\n'));
        const whatsappMobileLinkPeru = "whatsapp://send?text=" + storeTrans[storeId]['Message1'] + storeTrans[storeId]['Message2'] + encodeURIComponent(wishListPeru.join('\n'));
        const whatsappLink = "https://web.whatsapp.com/send?text=" + (storeId == portugalMKId ? "" : storeTrans[storeId]['Message1']) + storeTrans[storeId]['Message2'] + encodeURIComponent(wishList.join('\n'));
        const whatsappMobileLink = "whatsapp://send?text=" + (storeId == portugalMKId ? "" : storeTrans[storeId]['Subject']) + storeTrans[storeId]['Message2'] + encodeURIComponent(wishList.join('\n'));
        const smsLink = getMobileOS() === 'iOS' ? 'sms:&body=' + storeTrans[storeId]['Subject'] + encodeURIComponent(wishList.join('\n')) : 'sms:?body=' + encodeURIComponent(wishList.join('\n'));

        if(storeId === russiaMKId || storeId === spainMKId || storeId === polandMKId) {
            return (
                <>
                {showSocialIcon && <div style={{ width: 'auto' }}>
                    {(storeId === polandMKId && isMobile) && <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="SMS" analyticsFunc={SMSButtonClicked} sharingIcon={smsIcon} sharingLink={smsLink} fontFamilyByStore={fontFamilyByStore} />}
                    {(storeId === polandMKId) && <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="WHATSAPP" analyticsFunc={WhatsappButtonClicked} sharingIcon={whatsappIcon} sharingLink={isMobile ? whatsappMobileLinkPeru : whatsappLinkPeru} fontFamilyByStore={fontFamilyByStore} />}
                    <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="EMAIL" analyticsFunc={EmailButtonClicked} sharingIcon={emailIcon} sharingLink={emailLinkPeru} fontFamilyByStore={fontFamilyByStore} />
                    <p style={{...fontFamilyByStore, fontSize: '10px', color: '#000', textAlign: 'center', padding: "0px 0 1em", maxWidth: "280px", margin: "10px auto 0"}}>{renderWishlistText()}</p>
                </div>}
                </>
            ); 
        } else {
            return (
                <div className='wishlist-sharing' style={{ width: 'auto' }}>
                    {storeId === argentinaMKId && <div className='wishlist-sharing-heading' style={{fontSize:'11px'}}>{storeTrans[storeId]['WishlistHeading1']}</div>}
                    {storeId === ukMKId ? <div className='wishlist-sharing-heading'>{storeTrans[storeId]['WishlistHeading']} <a href=" https://www.marykay.co.uk/en-gb/find-an-independent-beauty-consultant" style={{color:'#D84176',textDecoration: 'underline'}} target="_blank">Independent Beauty Consultant.</a> </div> : (storeId === portugalMKId ? <div className='wishlist-sharing-heading'>Partilhe a sua Lista de Desejos com a sua <a href=" https://www.marykay.pt/pt-pt/contactar-uma-cb" style={{ color: '#D84176', textDecoration: 'underline' }} target="_blank"> Consultora de Beleza Independente </a> Mary Kay!</div> : <div style={fontFamilyByStore} className={`wishlist-sharing-heading ${storeId === argentinaMKId?'fontSize11':''}`}>{storeTrans[storeId]['WishlistHeading']}</div>)}
                    {(storeId === peruMKId) ? <div className='wishlist-sharing-heading-consult' ><p>{storeTrans[storeId]['heading1']}</p> <span><a className="wishlist-consult-link" onClick={() => ContactButtonClicked()} href={changeLink()} target="_blank">{storeTrans[storeId]['heading2']}</a></span></div> :
                    storeId === moldovaMKId ? <div className='wishlist-sharing-heading'>Distribuie lista ta de produse preferate <a href={changeLink()} style={{ color: '#D84176', textDecoration: 'underline' }} target="_blank"> Consultantului tău Independent de frumusețe.</a></div> :
                        <div style={fontFamilyByStore} className={`wishlist-sharing-heading-consult ${(storeId === argentinaMKId)?'fontSize11':''}`}>{storeTrans[storeId]['heading1']} <a className="wishlist-consult-link" onClick={() => ContactButtonClicked()} href={changeLink()} target="_blank">{storeTrans[storeId]['heading2']}</a><span>{storeTrans[storeId]['heading3']}</span></div>}
                    {(storeWithShareBtn.includes(storeId)) &&
                        <div className="share-panel">
                            <button onClick={()=>setShowShareIcon(!showShareIcon)} className="call-to-order-btn-wrapper share-btn" style={{ margin: '15px 45px 10px',cursor: 'pointer' }} >
                                <span className="call-to-order-btn" >{storeTrans[storeId]['shareBtn'] ? storeTrans[storeId]['shareBtn']: 'Share'}</span>
                            </button>
                            {storeTrans[storeId]['priceTerms'] && <div className="priceTerms wishlist-sharing-heading-consult">{storeTrans[storeId]['priceTerms']}</div>}
                            {showShareIcon &&
                                <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="EMAIL" analyticsFunc={EmailButtonClicked} sharingIcon={emailIcon} sharingLink={emailLink} />
                            }
                            {isMobile && showShareIcon  ?
                                <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="SMS" analyticsFunc={SMSButtonClicked} sharingIcon={smsIcon} sharingLink={smsLink} />
                                : ''}
                            { showShareIcon &&
                                <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="WHATSAPP" analyticsFunc={WhatsappButtonClicked} sharingIcon={whatsappIcon} sharingLink={isMobile ? whatsappMobileLink : whatsappLink} />
                            }
                        </div>
                    }

                    {!storeWithShareBtn.includes(storeId) &&
                    <>
                        {storeId === peruMKId ? <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="WHATSAPP" analyticsFunc={WhatsappButtonClicked} sharingIcon={whatsappIcon} sharingLink={isMobile ? whatsappMobileLinkPeru : whatsappLinkPeru} /> :
                        <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="WHATSAPP" analyticsFunc={WhatsappButtonClicked} sharingIcon={whatsappIcon} sharingLink={isMobile ? whatsappMobileLink : whatsappLink} fontFamilyByStore={fontFamilyByStore} />}
                        {storeId === peruMKId ? <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="EMAIL" analyticsFunc={EmailButtonClicked} sharingIcon={emailIcon} sharingLink={emailLinkPeru} /> :
                            <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="EMAIL" analyticsFunc={EmailButtonClicked} sharingIcon={emailIcon} sharingLink={emailLink} fontFamilyByStore={fontFamilyByStore} />}
                        {isMobile ?
                            <WishlistSharingButton className="dark-bg" isCentered={true} sharingType="SMS" analyticsFunc={SMSButtonClicked} sharingIcon={smsIcon} sharingLink={smsLink} fontFamilyByStore={fontFamilyByStore} />
                        : ''}
                    </>
                    }
                </div>
            );
        }
    }

    const handleCheckout = () => {
        let checkoutUrl = getCheckoutURL(storeId);
        let skuIds = cartList.map((item) => item.SKU).join(',');
        checkoutUrl = checkoutUrl.replace('SKUIDS', skuIds)
        if([ukMKId,russiaMKId,spainMKId,polandMKId].includes(storeId)) {
            CheckoutClicked();
        }
        window.open(checkoutUrl, '_blank')
    }

    if (!showDropdown) {
        return (<div />);
    }
    return (
        <React.Fragment>
            {cartList.length !== 0 && <div id='add-to-cart-arrow' />}
            <div id='add-to-cart-menu'>
                {renderCartItems()}
                {cartList.length !== 0 && [ukMKId, russiaMKId, spainMKId, portugalMKId, polandMKId, moldovaMKId].includes(storeId) && <CartDropdownFooter onClick={handleCheckout} showSocialIcon={showSocialIcon} setSocialIcon={() => fnSocialIcon} showCheckoutIcon={showCheckoutIcon} setCheckoutIcon={() => fnCheckoutIcon} fontFamilyByStore={fontFamilyByStore} />}
                {cartList.length !== 0 && renderSharingButtons()}
            </div>
        </React.Fragment>
    );
}

CartDropdown.propTypes = {
    showMenu: PropTypes.bool,
    linkedStores: PropTypes.array,
    currentStoreIndex: PropTypes.number,
    menuTextFontStyle: PropTypes.object,
    menuTitle: PropTypes.string,
    sceneIdNameDict: PropTypes.object,
    storeId: PropTypes.string
};

export default CartDropdown;
